import { render, staticRenderFns } from "./listOrder.vue?vue&type=template&id=2bc614d8&scoped=true&"
import script from "./listOrder.vue?vue&type=script&lang=js&"
export * from "./listOrder.vue?vue&type=script&lang=js&"
import style0 from "./listOrder.vue?vue&type=style&index=0&id=2bc614d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc614d8",
  null
  
)

export default component.exports